import { Libraries } from '@react-google-maps/api';

export const GOOGLE_MAPS_API_LIBRARIES: Libraries = ['places'];

export type LatLngLiteral = google.maps.LatLngLiteral;
export type LatLngBounds = google.maps.LatLngBounds;
export type MapOptions = google.maps.MapOptions;
